import Header from './Components/Header';
import Home from './Pages/Home';
import Products from './Pages/Products'
import ProductDetails from './Pages/ProductDetails';
import Panier from './Components/panier';
import SommeNous from './Components/Sommes-nous';
import NosMarques from './Pages/Nos marques';
import ProductsMarques from './Pages/ProductsMarques';
import Promos from './Pages/Promos';
import PromoDetails from './Pages/PromoDetails';
import Politiques from './Components/Politiques';
import SearchResults from './Components/ProductSearch';
import Product100 from './Pages/Product100';
import Product50 from './Pages/Product50';
import VenteFlashPage from './Pages/VenteFlashPage';
import ProductOfSeason from './Pages/ProductOfSeason';
import { BrowserRouter,Route,Routes } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const track_id="G-T6622GHTPT";

function App() {
   const [cartCount, setCartCount] = useState(0);

  // Initialise le compteur à partir du localStorage
  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const total = cart.reduce((acc, item) => acc + item.quantite, 0);
    setCartCount(total);
  }, []);

  // Fonction à passer aux ProductCard
  const handleAddToCart = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const total = cart.reduce((acc, item) => acc + item.quantite, 0);
    setCartCount(total);
  };

  
 useEffect(() => {
  ReactGA.initialize(track_id);
}, []);
  function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Google Analytics
    ReactGA.pageview(location.pathname);

    // Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }

  }, [location]);

  return null;
}
  return (
    <div className="App">
        <BrowserRouter>
        <RouteTracker /> 
       <Header cartCount={cartCount} />
      <Routes>
          <Route path='/' element={<Home onAddToCart={handleAddToCart}/>} />
          <Route path="/collections" element={<Products onAddToCart={handleAddToCart} />}/> 
          <Route path="/:name/:name" element={<Products onAddToCart={handleAddToCart} />}/>
          <Route path="/collections/:name/:name" element={<Products onAddToCart={handleAddToCart} />}/>
          <Route path="/collections/:name/:name/:name" element={<Products onAddToCart={handleAddToCart} />}/>
          <Route path="/collections/:name/:name/:name/:name" element={<Products onAddToCart={handleAddToCart} />}/>
<Route path="/produit/:name/:name/:name" element={<ProductDetails onAddToCart={handleAddToCart} />}/>
<Route path="/produit/:name/:name/:name/:name" element={<ProductDetails onAddToCart={handleAddToCart} />}/>
<Route path="/produit/:name/:name/:name/:name/:name" element={<ProductDetails onAddToCart={handleAddToCart} />}/>
          <Route path="/bons-plans/:name" element={<PromoDetails/>}/>
      <Route path='/panier' element={<Panier onCartChange={handleAddToCart} />} />

          <Route path='/qui-sommes-nous' element={<SommeNous/>}/>
          <Route path='/politique-de-confidentialite' element={<Politiques/>}/>
          <Route path='/nos-marques' element={<NosMarques/>}/>
          <Route path="/:name" element={<ProductsMarques/>}/>
          <Route path='/bons-plans' element={<Promos/>}/>
          <Route path="/nos-petits-prix" element={<Product50/>}/>
          <Route path="/collections/tout-a-100-dt" element={<Product100/>}/>
           <Route path="/-100" element={<Product100/>}/>
          <Route path="/vente-flash" element={<VenteFlashPage/>}/>
          <Route path="/selection-du-mois" element={<ProductOfSeason/>}/>
          <Route path="/search" element={<SearchResults/>}/>
         </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
